export const serviceItems = [

{
  icon: 'fa fa-solid fa-code',
  title: 'Frontend Development',	
  description: 'Build fast, responsive, and modern web applications with React, Next.js, and Angular.'
},

{
  icon: 'fab fa-brands fa-react',
  title: 'React.js & Next.js Development',	
  description: 'Create scalable, component-driven React & Next Js applications with clean and maintainable code.'
},

{
  icon: 'fab fa-angular',
  title: 'Angular Development',	
  description: 'Build secure, enterprise-grade Angular applications with reusable architecture.'
},

{
  icon: 'fa-solid fa-pencil-ruler',
  title: 'UI/UX Implementation',	
  description: 'Transform Figma or Adobe XD designs into pixel-perfect, responsive user interfaces.'
},

{
  icon: 'fa-solid fa-plug-circle-bolt',
  title: 'API Integration',	
  description: 'Connect your application with REST, GraphQL, and third-party APIs for seamless functionality.'
},

{
  icon: 'fa-solid fa-gauge-high',
  title: 'Performance Optimization',	
  description: 'Improve loading speed, Core Web Vitals, and overall user experience.'
},

{
  icon: 'fa-solid fa-laptop-code',
  title: 'Responsive Web Design',	
  description: 'Ensure your website looks and works perfectly across desktop, tablet, and mobile devices.'
},

{
  icon: 'fa-solid fa-screwdriver-wrench',
  title: 'Maintenance & Support',
  description: 'Keep your application secure, updated, and running smoothly with ongoing support.'
  },

{
  icon: 'fa-solid fa-code-branch',
  title: 'Code Review & Refactoring',	
  description: 'Improve code quality, scalability, and maintainability with expert reviews and optimization.'
},

{
  icon: 'fa-solid fa-plug-circle-bolt',
  title: 'AI Integration',	
  description: 'Integrate AI features such as ChatGPT, automation, and intelligent workflows into your applications.'
},

{
  icon: 'fa-solid fa-lightbulb',
  title: 'Technical Consulting',	
  description: 'Get expert guidance on architecture, frontend strategy, and technology decisions.'
},
]

// NOTE: prices, plan names, and feature bullets below are the original
// theme's placeholder/dummy copy ("Dolorum sed doloribus" etc.) — swap in
// your real pricing/offer text before publishing.
export const pricingPlans = [
  {
    title: 'Hourly payment',
    price: '$17',
    period: '/hour',
    shortDesc: 'Need expert frontend support on demand? Whether it\'s building new features, fixing bugs, improving performance, or integrating APIs, I can help deliver clean, scalable, and maintainable solutions.',
    features: [

      { text: 'React.js, Next.js & Angular development', included: true},
      { text: 'Responsive and pixel-perfect UI implementation', included: true},
      { text: 'API integration and bug fixing', included: true},
      { text: 'Performance optimization and code refactoring', included: true},
      { text: 'Ongoing maintenance and technical support', included: true},
    ],
    ctaLabel: 'Hire me',
    ctaLink: '/contact',
  },
  {
    title: 'Monthly payment',
    price: '$2,900',
    period: '/month',
    shortDesc: 'A dedicated frontend developer for your team, ideal for startups and businesses that need consistent development, faster delivery, and ongoing collaboration.',
    features: [
      { text: 'Full-time frontend development (160 hours/month)', included: true},
      { text: 'React.js, Next.js & Angular development', included: true},
      { text: 'New feature development and bug fixes', included: true},
      { text: 'API integration and performance optimization', included: true},
      { text: 'Daily communication and progress updates', included: true},
      { text: 'Long-term maintenance and technical support', included: true}
    ],
    ctaLabel: 'Hire Me',
    ctaLink: '/contact',
  },
]
